import React from "react";
import {
  Box,
  Button,
  ThemeProvider,
  createTheme,
} from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../shared/hooks/sharedHooks";
import { useNavigate } from "react-router-dom";
import { AdminInventoryState } from "../../models/AdminStockItemsModels";
import { selectStockItem } from "../../adminStockItemsSlice";
import Title from "./detailsComponents/Title";
import Main from "./detailsComponents/Main";
import useTranslation from '../../../shared/hooks/useTranslation';

const InventoryDetails = () => {
  const { stockItem, loading, success, error } = useAppSelector<AdminInventoryState>((state: any) => state.adminInventory);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { translate: tCommon } = useTranslation('common');

  const handleClose = () => {
    dispatch(selectStockItem(null));
  };

  const handleEditProduct = () => {
    if (!stockItem) {
      return;
    }

    navigate(`/admin/inventory/${stockItem.id}`);
  };

  const theme = createTheme({
    components: {}
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        className="flex flex-col justify-between h-full"
        sx={{ width: 375, background: "#FFF", color: "#333", padding: "16px" }}>
        <Box>
          <Title stockItem={stockItem} onClose={handleClose} />

          <Main stockItem={stockItem} className="mt-4" />
        </Box>

        <Box>
          <Button variant="outlined" onClick={handleEditProduct} className="w-full">
            {tCommon('buttons.edit', { defaultValue: 'Edit Item' })}
          </Button>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
export default InventoryDetails;
